function AdminWorkspaceLoading({ error, onRetry, onLogout }) {
  return (
    <main className="admin-workspace-loading" aria-live="polite">
      <section>
        <h1>{error ? 'Admin data unavailable' : 'Loading admin workspace…'}</h1>
        {error && (
          <>
            <p>{error}</p>
            <button type="button" onClick={onRetry}>Retry connection</button>
            <button type="button" onClick={onLogout}>Sign out</button>
          </>
        )}
      </section>
    </main>
  );
}

export default AdminWorkspaceLoading;
